import { Container, Grid, Paper } from '@material-ui/core'
import React, { useState } from 'react'
import { components, useTranslation } from 'cng-web-lib'

import PartyMappingViewForm from './PartyMappingViewForm'
import PartyMappingEditForm from './PartyMappingEditForm'
import { useParams } from 'react-router-dom'
import Namespace from 'src/constants/locale/Namespace'
import PartyMappingKeys from 'src/constants/locale/key/PartyMapping'

const { CngTabs } = components


function EditPage({ showNotification }) {
	const { id } = useParams()
  const { translate } = useTranslation([Namespace.PARTY_MAPPING])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let partyMapping = translate(
      Namespace.PARTY_MAPPING,
      PartyMappingKeys.TITLE
    )

    return {
      partyMapping
    }
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <PartyMappingViewForm
							showNotification={showNotification}
							id={id}
							onFetchPreSuccess={(datum) => {
                //do nothing
              }}
						/>
          </Container>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.partyMapping,
              tabContent: (
                <PartyMappingEditForm
                  showNotification={showNotification}
                  id={id}
                />
              )
            },
          ]}
        />
      </Grid>
    </Grid>
  );
}

export default EditPage